var CryptoJS = require('crypto-js');

const generate = {
  SHA256
};

function SHA256() {
  var hmac = CryptoJS.algo.SHA256.create();
  var hash = hmac.finalize();

  return hash.toString(CryptoJS.enc.Base64);
}

export default generate;